import * as React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import * as KrispyTokens from '@krispy-tokens/blue';

const propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  numberOfLines: PropTypes.oneOf(['auto', 1, 2, 5]),
};

const TD = styled.td`
  position: relative;
  width: auto;
  white-space: nowrap;
  padding: ${KrispyTokens.KrispySpacingElementsMdSmall}px 
  ${KrispyTokens.KrispySpacingElementsHdXlarge}px;
`;

const Wrapper = styled.div`
  padding-left: 24px;
  display: -webkit-box;
  -webkit-line-clamp: ${({ numberOfLines }) => numberOfLines};
  -webkit-box-orient: vertical;
  overflow: visible;
  word-break: break-word;
`;

const Cell = (props) => {
  const { children, className, numberOfLines = 2 } = props;

  return (
    <TD className={className}>
      <Wrapper numberOfLines={numberOfLines}>{children}</Wrapper>
    </TD>
  );
};

Cell.propTypes = propTypes;

export default Cell;
